module.exports = __webpack_public_path__ + "img/passing.6523f84a.png";